import React from 'react';
import styles from './index.module.scss';

export default {
  // 绿色
  Success: ({ children, shadow = false }) => <span className={`${styles['success-color']} ${shadow ? styles.shadow : ''}`}>{children}</span>,
  // 黄色
  Warning: ({ children, shadow = false }) => <span className={`${styles['warning-color']} ${shadow ? styles.shadow : ''}`}>{children}</span>,
  // 红色
  Error: ({ children, shadow = false }) => <span className={`${styles['error-color']} ${shadow ? styles.shadow : ''}`}>{children}</span>,
  // 蓝色
  Info: ({ children, shadow = false }) => <span className={`${styles['info-color']} ${shadow ? styles.shadow : ''}`}>{children}</span>,
  // 灰色
  Disable: ({ children, shadow = false }) => <span className={`${styles['disable-color']} ${shadow ? styles.shadow : ''}`}>{children}</span>,
  // 黑色
  Text: ({ children, shadow = false }) => <span className={`${styles['text-color']} ${shadow ? styles.shadow : ''}`}>{children}</span>,
};
